// TODO 추후 플러그인 출시 시에는 아마 id값을 회사측의 id값으로 바꿔야 할수도..?
export const FIGMA_PLUGIN_ID = "1360480077146322091";
